import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that resets the window scroll position
 * to (0,0) whenever the route (pathname) changes.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to the top of the window on pathname change
        window.scrollTo(0, 0);
    }, [pathname]);

    // This component doesn't render anything visually
    return null;
};

export default ScrollToTop;
